import Header from './components/Header';
import Hero from './components/Hero';
import TrendingSection from './components/TrendingSection';
import FeaturedSection from './components/FeaturedSection';
import CrashSection from './components/CrashSection';
import ArchiveSection from './components/ArchiveSection';
import ControversySection from './components/ControversySection';
import FaqSection from './components/FaqSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50 text-foreground-950">
      <Header />
      <main>
        <Hero />
        <TrendingSection />
        <FeaturedSection />
        <CrashSection />
        <ArchiveSection />
        <ControversySection />
        <FaqSection />
      </main>
      <Footer />
    </div>
  );
}